module.exports = __webpack_public_path__ + "media/images/lp_v6_img05-cacb9ed905d0540e837810deb5cb0163.webp";